import { NftOwnership } from "@devour/client";

/**
 * Lootbox burning is a 3 step process that takes ~10 seconds.
 * If closes the modal or refreshes then the lootbox might still be in their wallet but not available for redeeming.
 * @param nftOwnership
 */
export default function isLootboxUnburnt(nftOwnership: NftOwnership): boolean {
    const oneMinsAgo = Date.now() - 60 * 1000;
    // If burn attempt occurred over a minute ago but still hasn't been successfully burned then let them retry.
    return !nftOwnership.burnedAt || nftOwnership.burnedAt < oneMinsAgo;
}